import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { isAnalyticsSuppressed } from '../analytics';
import { logPageView } from './storefrontEvents';

/** Log each storefront route change for session journey analytics. */
export default function StorefrontPageViewTracker() {
  const location = useLocation();
  const { token } = useAuth();
  const lastLoggedRef = useRef('');

  useEffect(() => {
    if (isAnalyticsSuppressed()) return undefined;
    const path = `${location.pathname}${location.search}`;
    if (!path || path.startsWith('/admin')) return undefined;
    if (lastLoggedRef.current === path) return undefined;
    lastLoggedRef.current = path;
    logPageView({ pagePath: path, authToken: token || null });
    return undefined;
  }, [location.pathname, location.search, token]);

  return null;
}
